// Inter comes embedded with the document (embedDocumentFonts). The other fonts are the fallback.
const DOCUMENT_FONT_FAMILY = 'Inter, Roboto, Arial, sans-serif';

// Standalone print documents use physical units independently of application CSS.
export const REPORT_DOCUMENT_STYLES = `
  @page { size: A4 portrait; margin: 18mm 11mm 16mm;
    @bottom-right { content: counter(page) " / " counter(pages); color: #17243e; font: 8pt ${DOCUMENT_FONT_FAMILY}; }
  }
  * { box-sizing: border-box; }
  html { color: #17243e; font: 8pt/1.25 ${DOCUMENT_FONT_FAMILY}; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  body { margin: 0; background: white; }
  .page-header { display: none; align-items: center; justify-content: space-between; gap: 1rem; border-bottom: .5pt solid #dde4ee; padding-bottom: .8rem; }
  .brand { font-weight: 700; font-size: 13pt; letter-spacing: .22em; }
  .context { color: #59677b; font-size: 8pt; text-align: right; max-width: 65%; overflow-wrap: anywhere; }
  h1 { margin: .25rem 0 .5rem; font-size: 14pt; line-height: 1.15; overflow-wrap: anywhere; }
  .metadata { color: #59677b; font-size: 7pt; margin: 0 0 .6rem; overflow-wrap: anywhere; }
  .filters { display: flex; flex-wrap: wrap; gap: .35rem .8rem; background: #f2f5fa; padding: .5rem .65rem; border-radius: .3rem; margin: 0 0 .7rem; }
  .filter-card { flex: 1 1 10rem; min-width: 0; }
  .filter-card span { display: block; color: #59677b; font-size: 7pt; }
  .filter-card strong { font-size: 8pt; overflow-wrap: anywhere; }
  .report-group { break-before: page; }
  .report-group:first-of-type { break-before: auto; }
  .group-charts { display: block; }
  .grouped .group-charts { display: grid; gap: .6rem; break-inside: avoid; }
  .columns-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .columns-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .report-section { min-width: 0; }
  h2 { display: flex; align-items: baseline; gap: .4rem; font-size: 11pt; line-height: 1.2; margin: 0 0 .45rem; }
  h2 span { font-size: 9pt; color: #165ddf; }
  .section-description { margin: 0 0 .45rem; color: #59677b; }
  .summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr)); gap: .4rem; margin: 0 0 .65rem; }
  .five-summaries { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .five-summaries .summary-card { padding: .5rem; }
  .five-summaries .summary-label { min-height: 2.8em; }
  .five-summaries .summary-value { font-size: 9pt; }
  .five-summaries .summary-exact { display: none; }
  .summary-card { position: relative; border-radius: .25rem; border: .75pt solid #dfe1e6; padding: .55rem; background: #fafbfc; min-width: 0; }
  .summary-dot { position: absolute; top: .55rem; right: .55rem; width: 5pt; height: 5pt; border-radius: 50%; }
  .summary-label { color: #59677b; display: block; font-size: 7pt; margin-bottom: .3rem; padding-right: .8rem; }
  .summary-value { display: block; font-size: 10pt; line-height: 1.15; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
  .summary-exact { color: #59677b; display: block; font-size: 6.5pt; margin-top: .25rem; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
  .chart { display: flex; align-items: center; justify-content: center; min-width: 0; break-inside: avoid; }
  .chart svg { max-width: 100%; height: auto; }
  .chart .recharts-wrapper { max-width: 100%; }
  .document-legend { display: flex; flex-wrap: wrap; justify-content: center; gap: .25rem .8rem; color: #59677b; font-size: 7pt; padding-top: .25rem; }
  .document-legend span { display: inline-flex; align-items: center; gap: .4rem; }
  .grouped .report-section { background: #f2f5fa; border-radius: .4rem; padding: .55rem .45rem .3rem; }
  .grouped h2 { font-size: 9pt; min-height: 2.4em; margin-bottom: .3rem; }
  .compact-summary { padding: 0 .25rem .3rem; min-height: 2.8rem; }
  .columns-3 .compact-summary { min-height: 0; }
  .compact-summary strong { display: block; font-size: 11pt; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
  .compact-summary small { font-size: 7pt; color: #59677b; }
  .table-block { margin-top: .6rem; }
  .table-block.keep-together { break-inside: avoid; }
  .chart-data-table { border-collapse: collapse; table-layout: auto; width: 100%; font-variant-numeric: tabular-nums; }
  .chart-data-table caption { text-align: left; font-size: 8pt; font-weight: 700; padding: 0 0 .3rem; break-after: avoid; }
  .chart-data-table thead { display: table-header-group; }
  .chart-data-table tfoot { display: table-row-group; break-before: avoid; break-inside: avoid; }
  .chart-data-table tbody tr:last-child { break-after: avoid; }
  .chart-data-table tr { break-inside: avoid; }
  .chart-data-table th, .chart-data-table td { border-bottom: .35pt solid #dde4ee; padding: .1rem .35rem; font-size: 7pt; line-height: 1.2; text-align: right; }
  .chart-data-table thead th { color: #59677b; background: #f2f5fa; font-size: 7pt; vertical-align: bottom; overflow-wrap: anywhere; }
  .chart-data-table tbody th, .chart-data-table tfoot th { text-align: left; font-weight: 400; min-width: 4rem; max-width: 168pt; overflow-wrap: anywhere; }
  .chart-data-table thead th:first-child { text-align: left; }
  .chart-data-table td { white-space: nowrap; }
  .chart-data-table tbody tr:nth-child(even) { background: #fafbfd; }
  .chart-data-table .incomplete-row { background: #fff4e5; }
  .chart-data-table tfoot th, .chart-data-table tfoot td { font-weight: 700; background: #f2f5fa; }
  .ranked-tables { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .7rem; }
  .ranked-tables .chart-data-table td, .ranked-tables .chart-data-table th { padding-top: .15rem; padding-bottom: .15rem; }
  .ranked-tables .category-bar { height: .25rem; margin-top: .2rem; }
  .category-bar { display: block; width: 100%; height: .45rem; max-width: 18rem; margin-top: .35rem; }
  .section-notes { margin-top: .45rem; break-inside: avoid; }
  .section-note { margin: .3rem 0 0; color: #59677b; font-size: 7pt; overflow-wrap: anywhere; }
  .empty-chart { color: #59677b; padding: 2rem 0; }
  .document-footer { display: none; border-top: .5pt solid #dde4ee; padding-top: .5rem; color: #59677b; font-size: 7pt; line-height: 1.3; }
  .document-footer span { display: block; overflow-wrap: anywhere; }
  @media screen { body { max-width: 184mm; margin: 8mm auto; padding: 8mm; } .page-header { display: flex; } .document-footer { display: block; } .report-group { margin-bottom: 3rem; } }
`;

// Encode all text as CSS escapes so filter values cannot close the style element.
export function createReportDocumentPageMargins(context: string, footer: string) {
  const cssString = (value: string) =>
    `"${Array.from(value, (character) => `\\${character.codePointAt(0)?.toString(16)} `).join('')}"`;
  return `@page {
    @top-left { content: "OMNETIC"; color: #17243e; font: bold 11pt ${DOCUMENT_FONT_FAMILY}; letter-spacing: .2em; width: 28%; }
    @top-right { content: ${cssString(context)}; color: #59677b; font: 8pt ${DOCUMENT_FONT_FAMILY}; width: 70%; overflow-wrap: anywhere; }
    @bottom-left { content: ${cssString(footer)}; white-space: pre-line; color: #59677b; font: 7pt/1.3 ${DOCUMENT_FONT_FAMILY}; width: 85%; overflow-wrap: anywhere; }
  }`;
}
